__turbopack_context__.v({
  "closeButton": "notifications-module__FwJmxG__closeButton",
  "description": "notifications-module__FwJmxG__description",
  "loader": "notifications-module__FwJmxG__loader",
  "root": "notifications-module__FwJmxG__root",
  "title": "notifications-module__FwJmxG__title",
});
